var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7127_17492)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.36255 4.41829L8.69588 3.08496H3.36255V14.4183H4.69588V9.75163H8.02922L8.69588 11.085H13.3625V4.41829H9.36255ZM12.0292 9.75163H9.36255L8.69588 8.41829H4.69588V4.41829H8.02922L8.69588 5.75163H12.0292V9.75163Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7127_17492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0292969 0.417969)"
  })))));
};
export default SvgFlag;